import React, { useState } from 'react';
import axios from 'axios';

const SignIn = ({ setMessage }) => {
    const [loginData, setLoginData] = useState({
        email: '',
        password: '',
    });

    const handleLoginChange = (e) => {
        setLoginData({ ...loginData, [e.target.name]: e.target.value });
    };

    const handleLoginSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await axios.post('http://localhost:3000/login', loginData);
            setMessage(response.data.message || 'Login successful!');
        } catch (error) {
            setMessage(error.response?.data?.message || 'Login failed!');
        }
    };

    return (
        <div className="auth-container">
            <form onSubmit={handleLoginSubmit} className="auth-form">
                <h2>Sign In</h2>
                <input
                    type="email"
                    name="email"
                    placeholder="Email"
                    value={loginData.email}
                    onChange={handleLoginChange}
                    required
                />
                <input
                    type="password"
                    name="password"
                    placeholder="Password"
                    value={loginData.password}
                    onChange={handleLoginChange}
                    required
                />
                <button type="submit" className="btn">Login</button>
            </form>
        </div>
    );
};

export default SignIn;
